import gql from 'graphql-tag'

export const deviceOperatingModeUpdate = gql`
  mutation deviceOperatingModeUpdate($deviceId: ID!, $operatingMode: String!) {
    deviceOperatingModeUpdate(input: { deviceId: $deviceId, operatingMode: $operatingMode }) {
      success
    }
  }
`
